import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type DeleteOnboardingProcessStepResponse = ClientInferResponseBody<
  typeof contract.onboardingProcessSteps.delete,
  200
>;

export const deleteOnboardingProcessStepApi = async ({
  id,
}: {
  id: string;
}): Promise<DeleteOnboardingProcessStepResponse> => {
  const response = await api.onboardingProcessSteps.delete.mutation({
    params: { id },
    body: {},
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to delete onboarding process step", response.status, response.body);
};
